import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Influencer} from '../../../../models/influencer';
import {Router, ActivatedRoute} from '@angular/router';
import {NumberUtils} from '../../../utils/number.utils';
import {CommonConstant, listOrderedPlatforms} from '../../../app.constants';
import {UserService} from '../../../services/user.service';
import {
  ActionSource, ActivePages, TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';
import {CacheService} from '../../../services/cache/cache.service';
import { PercentNumberSuffixPipe } from '../../../pipes/custom-number-format.pipe';

@Component({
  selector: 'influencer-item',
  templateUrl: './influencer-item.component.html',
  styleUrls: ['./influencer-item.component.scss']
})
export class InfluencerItemComponent {

  @Input()
  public influencer: Influencer;
  @Input()
  public influencerGroupId: number;
  @Input()
  public isCampaignInfluencer = false;
  @Input()
  public isRecentlyVisitedInfluencerGroup: boolean;
  @Input()
  public campaignId: number;
  @Input()
  public isLoadingData: boolean;

  @Output()
  public eventSelectInfluencer = new EventEmitter<number>();

  @Output()
  public deleteInfluencerEvent = new EventEmitter<any>();
  @Output()
  public approveInfluencerEvent = new EventEmitter<any>();
  @Output()
  public rejectSuggestedInfluencer = new EventEmitter<any>();

  public platformList = [];

  constructor(private router: Router,
              private userService: UserService,
              private cacheService: CacheService,
              private activatedRoute: ActivatedRoute) {
    this.platformList = listOrderedPlatforms;
  }

  onSelectInfluencer(influencer, e) {
    this.eventSelectInfluencer.emit(influencer);
  }

  normalizeNumberData(value: number): string {
    return NumberUtils.normalizeNumberToString(value);
  }

  rejectInfluencer(e: any) {
    this.rejectSuggestedInfluencer.emit(this.influencer);
    e.preventDefault();
    e.stopPropagation();
  }

  deleteInfluencer(e) {
    this.deleteInfluencerEvent.emit([this.influencer]);
    e.preventDefault();
    e.stopPropagation();
  }

  approveInfluencer() {
    this.approveInfluencerEvent.emit(this.influencer);
  }

  hasPlatform(platformName, influencer) {
    if (!influencer || !influencer.platform) {
      return false;
    }

    return influencer.platform.toLowerCase().indexOf(platformName.toLowerCase()) >= 0;
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  getCountryCode(influencer) {
    return influencer && influencer.country_code ? influencer.country_code : CommonConstant.INTERNATION_COUNTRY_CODE;
  }

  get influencerLanguage() {
    if (!this.influencer || !this.influencer.language) {
      return null;
    }
    return this.influencer.language.name;
  }

  goToInfluencerDetails(influencerId) {
    this.cacheService.disableCacheRemoving();
    if (this.isCampaignInfluencer) {
      this.router.navigate([`/influencer/${influencerId}/campaign`], {
        queryParams: {
          activeAccount: this.activeAccount,
          from_path: this.router.url.split('?')[0],
          campaignInfluencerId: this.influencer.campaign_influencer_id,
          selectedCampaign: this.campaignId
        }
      });
    } else {
      this.router.navigate([`/influencer/${influencerId}/overview`], {queryParams: {group_id: this.influencerGroupId, activeAccount: this.activeAccount}});
    }
  }

  get eventDataForDeleteAction() {
    return {
      target: {
        id: this.influencer && this.influencer.influencer_id || '*',
        name: this.influencer && this.influencer.influencer_name || 'all',
        type: TargetType.INFLUENCER
      },
      params: {
        action: UserActionType.DELETE,
        source: ActionSource.PAGE
      },
      activePage: {
        type: ActivePages.GROUP_DETAILS,
      }
    };
  }

  get showLoader() {
    return this.isLoadingData && this.influencer.isNewAdded;
  }

  get postValue() {
    return this.influencer.isFailedUpdate ? '-' : this.normalizeNumberData(this.influencer.numberOfPosts);
  }

  get reachValue() {
    return this.influencer.isFailedUpdate ? '-' : this.normalizeNumberData(this.influencer.reach);
  }

  get impactValue() {
    const percentNumberSuffixTransform = new PercentNumberSuffixPipe();
    const impactNo = this.normalizeNumberData(this.influencer.impact);
    return this.influencer.isFailedUpdate ? '-' : percentNumberSuffixTransform.transform(Number(impactNo));
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/influencer-item/influencer-item.component.ts